module.exports = __webpack_public_path__ + "static/upload-91b25fc5625f6b32207cc5b8e65b5276.svg";